/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* =============================================================================
   RECHARGE — Quick shop integration
   Venue 18 quick shop fetches content dynamically and doesn't call
   ReChargeWidget.createWidget() automatically. This mirrors the integration
   that was baked into Venue 9's theme.js.

   Note: Venue 18 dispatches on:quick-shop:loaded and on:modal:opening on the
   <quick-shop> element itself (no bubbles), so we attach directly to each
   element rather than listening on document.
   ============================================================================= */
(function () {
  function initReChargeInQuickShop(quickShopEl) {
    if (!window.ReChargeWidget) return;

    // Venue 18 quick-shop.js reads [id^=ProductJson] in #setProductData() so
    // that element is present after content is fetched. Prefer it; fall back to
    // the per-variant JSON which carries featured_image.product_id.
    let prodId = null;

    const productJsonEl = quickShopEl.querySelector('[id^="ProductJson"]');
    if (productJsonEl) {
      try { prodId = JSON.parse(productJsonEl.textContent).id || null; } catch (e) {}
    }

    if (!prodId) {
      const variantDataEl = quickShopEl.querySelector('[id^="variant-data-"]');
      if (variantDataEl) {
        try {
          const v = JSON.parse(variantDataEl.textContent);
          prodId = v.product_id || (v.featured_image && v.featured_image.product_id) || null;
        } catch (e) {}
      }
    }

    if (!prodId) return;

    // Remove any previously injected widget before re-creating
    const existing = quickShopEl.querySelector('.rc_container_wrapper');
    if (existing) existing.remove();

    window.ReChargeWidget.createWidget({
      productId: prodId,
      injectionParent: `quick-shop#${CSS.escape(quickShopEl.id)} .quick-shop__main`,
      injectionMethod: 'append',
      selectors: {
        price: ['.price__number'],
        variant: ['variant-selects', 'variant-radios', 'variant-mixed-inputs']
      }
    });
  }

  function attachToQuickShop(quickShopEl) {
    // Fires once after a placeholder quick shop fetches and injects its content
    quickShopEl.addEventListener('on:quick-shop:loaded', function () {
      initReChargeInQuickShop(quickShopEl);
    });
    // Fires on every open — handles already-loaded quick shops on subsequent opens
    quickShopEl.addEventListener('on:modal:opening', function () {
      initReChargeInQuickShop(quickShopEl);
    });
  }

  // Attach to all quick-shop elements present at script execution time
  document.querySelectorAll('quick-shop').forEach(attachToQuickShop);
})();

/* =============================================================================
   RECHARGE — Fix widget on variant change (main product page)

   Two separate problems require two separate fixes:

   PROBLEM 1 — cart subscription meta (original 2026-04-20 fix):
   Venue 18 replaces the entire <product-form> element on every variant change,
   orphaning ReCharge's cart-submission listeners on the old form. The
   MutationObserver detects the replacement and reinsertes the widget so its
   connectedCallback re-runs and re-attaches those listeners to the new form.

   PROBLEM 2 — subscription price display not updating on size change:
   The widget element has a `default-variant-id` attribute baked in by Shopify
   at page render. Its connectedCallback reads this to fetch subscription
   pricing from ReCharge's API and renders the price. The widget caches its
   initialized state, so reinserting the same element does not cause it to
   re-fetch — subsequent connectedCallback calls are no-ops. Simply patching
   the attribute before reinsert (tried and confirmed not working) therefore
   has no effect.

   Fix: on each variant change, fetch a fresh copy of the section HTML rendered
   for the new variant, extract the widget element from it, and swap it in.
   A brand-new element has no cached state; its connectedCallback runs fully,
   reads the server-baked default-variant-id for the correct variant, and
   fetches the right subscription pricing from ReCharge. This is exactly what
   happens on a full page load with ?variant=... in the URL.
   ============================================================================= */
(function () {
  document.querySelectorAll('product-single').forEach(function (productSingle) {

    /* --- Problem 1 fix: MutationObserver for cart listener re-attachment --- */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].tagName === 'PRODUCT-FORM') {
            var rc = productSingle.querySelector('recharge-subscription-widget');
            if (!rc) return;
            var parent = rc.parentElement;
            var next = rc.nextSibling;
            rc.remove();
            next ? parent.insertBefore(rc, next) : parent.appendChild(rc);
            return;
          }
        }
      }
    }).observe(productSingle, { childList: true, subtree: true });

    /* --- Problem 2 fix: fetch fresh widget element on variant change --- */
    var variantSelector = productSingle.querySelector(
      'variant-selects, variant-radios, variant-mixed-inputs'
    );
    if (!variantSelector) return;

    var sectionId = variantSelector.dataset.section;
    var productUrl = variantSelector.dataset.url;

    variantSelector.addEventListener('on:variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !sectionId || !productUrl) return;

      // Fetch the section rendered for the new variant. Shopify bakes the
      // correct default-variant-id into the fresh widget element, so when
      // connectedCallback runs on the replacement element it fetches the right
      // subscription pricing from ReCharge automatically.
      fetch(productUrl + '?section_id=' + sectionId + '&variant=' + variant.id)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRc = doc.querySelector('recharge-subscription-widget');
          if (!newRc) return;
          var current = productSingle.querySelector('recharge-subscription-widget');
          if (current) {
            current.replaceWith(newRc);
          }
        })
        .catch(function () { /* network errors are silent; price just stays stale */ });
    });
  });
})();
